<template>
    <ValidationProvider :name="label" :rules="rules" v-slot="{ errors, required }" :mode="validationmode" :vid="computedVid" slim>
        <div class="migrol-form__input-wrapper" :class="[cssclass, { 'migrol-form__input-wrapper--error' : errors.length > 0 }]" :style="computedStyle">
            <label :for="$id('input')" class="migrol-form__input-label" v-if="label">{{label}}{{(required ? '*' : '')}}</label>
            <div class="migrol-form__input-container">
                <date-pick v-model="innerValue"
                           class="migrol-form__input-date"
                           v-bind="$attrs" :id="$id('input')"
                           v-on="inputListeners"
                           :displayFormat="'DD.MM.YYYY'"
                           :months="monthTexts"
                           :weekdays="weekdaysTexts"
                           :setTimeCaption="setTimeCaptionTexts"
                           :prevMonthCaption="prevMonthCaptionTexts"
                           :nextMonthCaption="nextMonthCaptionTexts"></date-pick>
            </div>
            <div class="migrol-form__error-message">{{errors[0]}}</div>
        </div>
    </ValidationProvider>
</template>

<script>
    import { ValidationProvider } from 'VeeValidate';
    import DatePick from 'VueDatePick';

    export default {
        inheritAttrs: false,
        props: {
            label: {
            },
            flex: {
                type: String,
                default: '1',
                required: false
            },
            value: {
                default: ''
            },
            rules: {
                type: [Object, String],
                default: null,
                required: false
            },
            validationmode: {
                type: [String, Function],
                required: false
            },
            vid: {
                type: String,
                default: ''
            },
            cssclass: {
                type: String,
                default: null,
                required: false
            }
        },
        data() {
            return {
                innerValue: ''
            }
        },
        computed: {
            computedStyle() {
                return this.flex != '1' ? { flex: this.flex } : null;
            },
            computedVid() {
                if (this.vid !== '')
                    return this.vid;
                else
                    return this.$id('vid');
            },
            inputListeners() {
                var vm = this
                // `Object.assign` merges objects together to form a new object
                return Object.assign({},
                    // We add all the listeners from the parent
                    this.$listeners,
                    // Then we can add custom listeners or override the
                    // behavior of some listeners.
                    {
                        // This ensures that the component works with v-model
                        input: function (event) {
                            vm.$emit('input', event)
                        }
                    }
                )
            },
            monthTexts() {
                return window.vueDatePickTexts['months'][window.CONFIG.language];
            },
            weekdaysTexts() {
                return window.vueDatePickTexts['weekdays'][window.CONFIG.language];
            },
            nextMonthCaptionTexts() {
                return window.vueDatePickTexts['nextMonthCaption'][window.CONFIG.language];
            },
            prevMonthCaptionTexts() {
                return window.vueDatePickTexts['prevMonthCaption'][window.CONFIG.language];
            },
            setTimeCaptionTexts() {
                return window.vueDatePickTexts['setTimeCaption'][window.CONFIG.language];
            }
        },
        watch: {
            value: {
                immediate: true,
                handler(newVal) {
                    this.innerValue = newVal;
                }
            }
        },
        components: {
            ValidationProvider,
            DatePick
        }
    }
</script>